import NavigationType from '../../enums/NavigationType';
import gtmPushDeliveryOptionUsed from '../google-tag-manager/gtmPushDeliveryOptionUsed';
import {isCollapsibleExperiment} from '../selectors/ExperimentSelectors';
import doMetric from '../tracking/bigQueryMetricRecorder';
import submitEventDataReader from '../tracking/submitEventDataReader';
import DomUtils from '../utils/DomUtils';
import Track from '../utils/tracking';
import V2Validation from '../validation/v2-validation';
import * as types from './action-types';
import {removePageMessage} from './pageMessageActions';

export function screenResized(width, height) {
  return {type: types.SET_SCREEN_DIMENSIONS, width, height};
}

export function setCheckoutProgressStep(stepNumber) {
  try {
    doMetric('mobileStep', [{name: 'page', value: stepNumber}]);
  } catch (error) {
    Track.track(error);
  }
  return {type: types.SET_CHECKOUT_PROGRESS_STEP, stepNumber};
}

export const updateSectionOrder = () => ({type: types.UPDATE_SECTION_ORDER});

export const updateSubscriptionSectionOrder = () => ({type: types.UPDATE_SUBSCRIPTION_SECTION_ORDER});

export const revertSectionOrder = () => ({type: types.REVERT_SECTION_ORDER});

export function stepForwards() {
  return (dispatch, getState) => {
    if (!isCollapsibleExperiment(getState())) {
      DomUtils.jumpToTop();
    }
    
    const currentPageNumber = getState().ui.checkoutProgressStep;
    const currentPageName = getState().ui.sections[currentPageNumber - 1];
    
    const validationResult = V2Validation.validate();
    
    if (!validationResult.isValid) { // Check the form is valid according to V2 validation
      try {
        const errors = submitEventDataReader.getErrors(validationResult.errors);
        doMetric('mobileStepButton', [{name: 'page', value: currentPageName}], errors);
      } catch (error) {
        Track.track(error);
      }
      
      if (currentPageNumber < window.history.state.stepNo) {
        window.history.back();
      }
    } else if (currentPageNumber < getState().ui.sections.length) { // sanity check
      if (window.history.state && (window.history.state.stepNo === currentPageNumber)) {
        try {
          doMetric('pushstate', [{name: 'reason', value: 'Navigating forwards'}]);
        } catch (error) {
          Track.track(error);
        }
        window.history.pushState({
          reason: NavigationType.STEP,
          stepNo: currentPageNumber + 1,
        }, '');
      }
      if (window.start.settings?.gtm_delivery_option_data_enabled && currentPageName === 'DELIVERY') {
        try {
          dispatch(gtmPushDeliveryOptionUsed(getState()));
        } catch (error) {
          Track.track(error);
        }
      }
      dispatch(setCheckoutProgressStep(currentPageNumber + 1));
      dispatch(removePageMessage());
    }
  };
}

export function stepToPage(desiredPage) {
  function stepBackWithScroll() {
    window.scrollTo(0, 1);
    window.scrollTo(0, 0);
    window.history.back();
  }
  
  return (dispatch, getState) => {
    const currentPageNumber = getState().ui.checkoutProgressStep;
    const pageGap = desiredPage - currentPageNumber;
    const stepsToTake = Math.abs(pageGap);
    
    try {
      doMetric('ProgressBarButton', [{
        name: 'currentPage',
        value: currentPageNumber,
      }, {
        name: 'desiredPage',
        value: desiredPage,
      }]);
    } catch (error) {
      Track.track(error);
    }
    
    // scrollTo's are to tackle a specific glitch on iOS
    if (pageGap < 0) {
      stepBackWithScroll();
      
      if (stepsToTake > 1) {
        setTimeout(() => {
          stepBackWithScroll();
        }, 0);
      }
    }
  };
}

export function stepBackwards() {
  return (dispatch, getState) => {
    if (!isCollapsibleExperiment(getState())) {
      DomUtils.jumpToTop();
    }
    doMetric('checkoutProgressStep', [{name: 'checkoutProgressStep', value: getState().ui.checkoutProgressStep}]);

    const currentPageNumber = getState().ui.checkoutProgressStep;
    if (currentPageNumber > 1) { // sanity check
      dispatch(setCheckoutProgressStep(currentPageNumber - 1));
      dispatch(removePageMessage());
    }
  };
}

export function handleHistoryStateChange(event) {
  return (dispatch, getState) => {
    const currentPageNumber = getState().ui.checkoutProgressStep;
    const isOverlayOpen = !!getState().overlay.selectedOverlay;
    try {
      doMetric('popstate', [
        {name: 'reason', value: event.state?.reason},
        {name: 'currentNumber', value: currentPageNumber},
        {name: 'stepNumber', value: event.state?.stepNo},
        {name: 'isOverlayOpen', value: isOverlayOpen},
      ]);
    } catch (error) {
      Track.track(error);
    }
    if (event.state?.reason === NavigationType.OVERLAY) { // never handle pressing forward for an overlay history entry
      window.history.back();
    } else if (isOverlayOpen) { // If an overlay is open
      const overlayWasClosed = DomUtils.closeOverlayIfClosable();
      if (!overlayWasClosed) {
        try {
          doMetric('pushstate', [{name: 'reason', value: 'overlay not closeable'}]);
        } catch (error) {
          Track.track(error);
        }
        window.history.pushState({reason: NavigationType.OVERLAY}, '');
      }
    } else if (currentPageNumber < event.state?.stepNo) {
      dispatch(stepForwards());
    } else if (currentPageNumber > event.state?.stepNo) {
      dispatch(stepBackwards());
    }
  };
}
